<template>
<v-main class="pa-3 pb-4">
  <div class="text-xs-center">
    <h1>
      <p class="text-sm-center font-weight-bold">Métricas da Unidade</p>
    </h1>
  </div>
  <v-card class="rounded-xl">
    <v-form ref="form" class="px-4 py-4">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="computedDateFormatted1" label="Data Início " hint="DD/MM/YYYY formato" persistent-hint prepend-icon="event" :rules="[
                  (v) =>
                    (v && v.length > 0) ||
                    'Escolha a data inicial para carregar os dados',
                ]" readonly required v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="pt-Br" v-model="date1" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm6>
          <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="computedDateFormatted2" :rules="[
                  (v) =>
                    (v && v.length > 0) ||
                    'Escolha a data final para carregar os dados',
                ]" label="Data Fim " hint="DD/MM/YYYY formato" persistent-hint prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="pt-Br" v-model="date2" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <!-- <v-flex xs12 sm2>
          <v-btn :loading="false" :disabled="false" color="primary" @click="carregarDadosTabelas">
            Carregar dados
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-flex> -->
      </v-layout>
    </v-form>
  </v-card>
  <div class="text-xs-center"></div>
  <br />

    <!-- <v-tabs v-model="tab" centered slider-color="yellow">
      <v-tab v-for="(t, i) of tabs" :key="i" :href="`#tab-${i}`">
         {{t.nome}}
        <v-icon>{{t.icon}}</v-icon>

      </v-tab>
    </v-tabs> -->

  <!-- <v-tabs-items v-model="tab">
    <v-tab-item v-for="i in 3" :key="i" :value="`tab-${i}`">
      <v-card flat>
        <v-card-text>456444444546</v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs-items> -->

  <v-tabs v-show="date1 !== '' && date2 !==''" centered icons-and-text class="white elevation-4 rounded-xl px-5">
    <v-tabs-slider color="primary"></v-tabs-slider>

    <v-tabs v-model="tab" centered slider-color="yellow" class="pt-2">
      <v-tab v-for="(t, i) of tabs" :key="i" :href="`#tab-${i}`">
         {{t.nome}}
        <v-icon>{{t.icon}}</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-progress-linear v-show="load" :indeterminate="true"></v-progress-linear>
      <v-divider class="mb-4"/>
      <v-tab-item :key="1" value="tab-0">
        <v-card flat>
          <Unidade :tempoEsperaPaciente="tempoAteRecepcionista" :tempoMedioUnidade="mediaAtendimentoUnidade" :esperaPacienteRecep="esperaPacienteRecep" :esperaDiaRecep="mediasAtendimento" v-if="!load"></Unidade>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2" value="tab-1">
        <v-card flat>
          <Recepcionista :atendimentoRecep="atendimentoRecep" v-if="!load"></Recepcionista>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="3" value="tab-2">
        <v-card flat>
          <Paciente :tempoEspera="tempoAteRecepcionista" v-if="!load"></Paciente>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="4" value="tab-3">
        <v-card flat>
          <Exame :exames="exames" v-if="!load"></Exame>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="5" value="tab-4">
        <v-card flat>
          <exameEspecialidade :exameEspecialidade="exameEspecialidade" v-if="!load"></exameEspecialidade>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
  <!-- *************DADOS GERAIS DA UNIDADE********************** -->

  <!-- ***************************TABELAS************************ -->
</v-main>
</template>

<script>
import administradorUnidadeService from './../../../services/administradorUnidade.service'
// import { EventBus } from './../../../main'
import Unidade from './../../administradorUnidade/metricas/Unidade'
import Recepcionista from './../../administradorUnidade/metricas/Recepcionista'
import Paciente from './../../administradorUnidade/metricas/Paciente'
import Exame from './../../administradorUnidade/metricas/Exame2'
import ExameEspecialidade from './../../administradorUnidade/metricas/ExameEspecialidade'

export default {
  name: 'funcionariosOnline',
  components: {
    Exame,
    Unidade,
    Recepcionista,
    Paciente,
    ExameEspecialidade
  },

  data: vm => ({
    tabs: [
      // { index: 0, nome: "Home", href: "#tab-1", icon: "home" },
      {
        index: 0,
        nome: 'Unidade',
        href: '#tab-0',
        icon: 'home'
      },
      // { index: 2, nome: "Médico", href: "#tab-3", icon: "person" },
      {
        index: 1,
        nome: 'Recepcionista',
        href: '#tab-1',
        icon: 'assignment_ind'
      },
      {
        index: 2,
        nome: 'Paciente',
        href: '#tab-2',
        icon: 'person'
      },
      {
        index: 3,
        nome: 'Exame',
        href: '#tab-3',
        icon: 'description'
      },
      {
        index: 4,
        nome: 'Exame Especialidade',
        href: '#tab-4',
        icon: 'note'
      }
      // { index: 6, nome: "Exame Especialidade", href: "#tab-3", icon: "phone" },

    ],
    tab: null,
    valid: true,
    quantAtendimentos: 0,
    mediaAtendimentoUnidade: '',
    esperaPacienteRecep: null,
    esperaDiaRecep: null,
    tempoEspera: 0,
    loadingTabela1: false,
    mediasAtendimento: '',
    load: 0,
    loadingTabela2: false,
    // date1: new Date().toISOString().substr(0, 10),
    // date2: new Date().toISOString().substr(0, 10),
    date1: '',
    date2: '',
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    search1: '',
    search2: '',
    exames: [],
    exameEspecialidade: null,
    tempoAteRecepcionista: '',
    listaFuncionariosTabela: [],
    atendimentoRecep: null,
    headers1: [{
      text: 'Recepcionista',
      align: 'center',
      value: 'nome'
    },
    {
      text: 'Quantidade de Atendimentos',
      align: 'center',
      value: 'quantAtendimentos'
    },
    {
      text: 'Média de Atendimento',
      align: 'center',
      value: 'mediaAtendimento'
    }
    ],
    headers2: [{
      text: 'Mes',
      align: 'center',
      value: 'mes',
      sortable: true
    },
    {
      text: 'Data',
      align: 'center',
      value: 'data'
    },
    {
      text: 'Tempo de espera',
      align: 'center',
      value: 'tempoEspera'
    },
    {
      text: 'Quantidade de atendimentos',
      align: 'center',
      value: 'quantAtendimentos'
    }
    ],
    listaTabela1: [{
      nome: '---',
      quantAtendimentos: '---',
      mediaAtendimento: '---'
    },
    {
      nome: '---',
      quantAtendimentos: '---',
      mediaAtendimento: '---'
    }
    ],
    listaTabela2: [{
      mes: '---',
      data: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    },
    {
      mes: '---',
      data: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    }
    ]
  }),

  props: {
    msg: String
  },
  mounted () {
    console.log('mounted Metricas')
    this.user = this.$store.getters.usuario
  },

  methods: {
    formatarTempo (tempo) {
      var a = tempo.split(':')
      var text = ''
      if (a[0] != '00') {
        text = a[0] + ' hr' + text
      }
      if (a[1] != '00') {
        text = a[1] + ' min' + text
      }
      if (a[2] != '00') {
        text = a[2] + ' sg' + text
      }
      return text
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    carregarDadosTabelas () {
      if (this.date1 !== '' && this.date2 !== '') {
        console.log('valido')
        //  ventBus.$emit('carregarDados', this.date1, this.date2)
        this.mediasTempoUnidade() // tabela
        this.tempoAtendimentoRecep()
        // this.tempoEsperaPacienteRecep() // esse so manda um dado
        // this.tempoEsperaDiaRecep() //
        this.retornarExameHora()
        this.retornarExameExpecialidadeHora()
      }
    },

    calculaMediaAtendimentoUnidade (lista) {
      if (!lista.length) {
        return 0
      }
      var produto = 0
      var somaAtendimentos = 0
      lista.forEach(data => {
        somaAtendimentos = somaAtendimentos + data.quantAtendimentos
        var hms = data.mediaAtendimento // your input string
        var a = hms.split(':') // split it at the colons
        var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2]
        var newSeconds = data.quantAtendimentos * seconds
        produto = produto + newSeconds
      })
      var result = produto / somaAtendimentos
      var date = new Date(result * 1000)
      var hh = date.getUTCHours()
      var mm = date.getUTCMinutes()
      var ss = date.getSeconds()
      // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
      // if (hh > 12) {hh = hh % 12;}
      // These lines ensure you have two-digits
      console.log('-----aaaa-----')
      console.log(hh, mm, ss)
      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      console.log(hh, mm, ss)
      // This formats your string to HH:MM:SS
      var t = hh + ':' + mm + ':' + ss
      return t
    },

    tempoAtendimentoRecep () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .tempoAtendimentoRecep(this.date1, this.date2)
        .then(rsp => {
          console.log('rsp mediasTempoUnidade:', rsp.data)
          this.atendimentoRecep = rsp.data
          // this.mediaAtendimentoUnidade = this.calculaMediaAtendimentoUnidade(
          //   rsp.data.lista
          // )
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch(err => {
          // handle your error
          // this.loadingTabela1 = false
          console.log(err)
        })
    },

    mediasTempoUnidade () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .mediasTempoUnidade(this.date1, this.date2)
        .then(rsp => {
          console.log('rsp mediasTempoUnidade:', rsp.data)
          this.mediasAtendimento = rsp.data
          // this.listaTabela1 = rsp.data.lista
          // this.loadingTabela1 = false
          this.esperaPacienteRecep = rsp.data
          this.quantAtendimentos = rsp.data.quantAtendimentos
          this.tempoAteRecepcionista = rsp.data.mediaTempoEspera
          this.mediaAtendimentoUnidade = rsp.data.mediaTempoTotal
          // this.mediaAtendimentoUnidade = this.calculaMediaAtendimentoUnidade(
          //   rsp.data.lista
          // )
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch(err => {
          // handle your error
          // this.loadingTabela1 = false
          console.log(err)
        })
    },

    /* tempoEsperaPacienteRecep () {
      this.load = this.load + 1
      // essa n precisa de tabela
      administradorUnidadeService.administradorUnidade
        .tempoEsperaPacienteRecep(this.date1, this.date2)
        .then(rsp => {
          console.log('rsp tempoEsperaPacienteRecep:', rsp.data)
          if (rsp.status == 200) {
            this.esperaPacienteRecep = rsp.data
            this.quantAtendimentos = rsp.data.quantAtendimentos
            this.tempoAteRecepcionista = rsp.data.tempoAteRecepcionista
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }, */

    /* tempoEsperaDiaRecep () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .tempoEsperaDiaRecep(this.date1, this.date2)
        .then(rsp => {
          console.log('rsp tempoEsperaDiaRecep:', rsp.data)
          this.esperaDiaRecep = rsp.data
          rsp.data.list.forEach(element => {
            var data = new Date(element.data)
            element.mes = data.getMonth() + 1
          })
          this.listaTabela2 = rsp.data
          this.loadingTabela2 = false
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch(err => {
          // handle your error here
          this.loadingTabela2 = false
          console.log(err)
        })
    }, */

    retornarExameHora () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .retornarExameHora(this.date1, this.date2)
        .then((rsp) => {
          console.log('rsp retornarExameHora', rsp.data)
          if (rsp.data.length > 0) {
            this.exames = rsp.data
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
    },

    retornarExameExpecialidadeHora () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .retornarExameEspexialidadeHora(this.date1, this.date2)
        .then((rsp) => {
          console.log('retornarExameEspexialidadeHora', rsp.data)
          if (rsp.status === 200) {
            this.exameEspecialidade = rsp.data
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          console.log(err)
        })
    },

    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    }
  },
  computed: {
    computedDateFormatted1 () {
      return this.formatDate(this.date1)
    },
    computedDateFormatted2 () {
      return this.formatDate(this.date2)
    }
  },

  watch: {
    date2: function (val) {
      if (this.date1 !== '') {
        this.carregarDadosTabelas()
      }
    },
    date1: function (val) {
      if (this.date2 !== '') {
        this.carregarDadosTabelas()
      }
    }
  },

  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
